import cx from 'classnames';
import React, { useMemo } from 'react';
import { RadioContext } from '../radio.context';
import styles from './radio-group.module.scss';
export const RadioGroup = ({ onChange, children, selectedValue, id, containerClassName, className, disabled = false, orientation = 'list', hideRadio = false, legendContent, ...restProps }) => {
    const handleChange = (event) => {
        onChange(event);
    };
    const radioGroupClassNames = cx(styles.radioGroup, className, {
        [styles.radioGroupTray]: orientation === 'tray',
        [styles.radioGroupList]: orientation === 'list',
    });
    const contextValue = useMemo(() => {
        return {
            selectedValue,
            hideRadio,
            itemClassName: styles.radioItem,
        };
    }, [hideRadio, selectedValue]);
    return (React.createElement(RadioContext.Provider, { value: contextValue },
        React.createElement("fieldset", { id: id, onChange: handleChange, disabled: disabled, className: cx(containerClassName, styles.radioFieldset), ...restProps },
            legendContent && (React.createElement("legend", { className: styles.radioLegend }, legendContent)),
            React.createElement("div", { className: radioGroupClassNames }, children))));
};
//# sourceMappingURL=radio-group.js.map